import MuiMenu from '@mui/material/Menu';
import MuiMenuItem from '@mui/material/MenuItem';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';

export const Menu = forwardRef<
  HTMLDivElement,
  ComponentPropsWithoutRef<typeof MuiMenu>
>((props, ref) => {
  return <MuiMenu {...props} ref={ref} />;
});

export const MenuItem = forwardRef<
  HTMLLIElement,
  ComponentPropsWithoutRef<typeof MuiMenuItem>
>((props, ref) => {
  return <MuiMenuItem {...props} ref={ref} />;
});
